export default __webpack_public_path__ + "static/media/IT.008ee7ca.svg";